import MUIAlert from '@mui/material/Alert';
import { useState } from 'react';
import styled from 'styled-components';
import { DesktopEventDrawer } from './details-drawer';
import { useEventListContext } from './event-list-context';
import { ListEventItem } from './list-view-item';

const ListEventItemsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin: 0 auto;
	max-width: 1000px;
	width: 100%;
	padding: 1rem;
`;
export function ListView() {
	const { events } = useEventListContext();
	return (
		<ListEventItemsWrapper>
			{events?.map(event => {
				const [deskTopDrawerOpen, setDesktopDrawerOpen] = useState<boolean>(false);
				return (
					<div style={{ width: '100%' }} key={event.id}>
						<div style={{ cursor: 'pointer' }} onClick={() => setDesktopDrawerOpen(true)}>
							<ListEventItem event={event} />
						</div>
						<DesktopEventDrawer drawerOpen={deskTopDrawerOpen} setDrawerOpen={setDesktopDrawerOpen} eventId={event.id} />
					</div>
				);
			})}
			{events?.length === 0 ? <MUIAlert severity="info">No events to display</MUIAlert> : null}
		</ListEventItemsWrapper>
	);
}
